import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

const ComplaintFilters = ({ filter }) => {
  const { ALL_STATUS_ID, LIST_OF_CATEGORIES } = constants.complaint

  const { response: usersResponse, isLoading: isUsersLoading } = useFetch(
    service.dponet.users.get,
    { minimal: true, perPage: 9999 },
    [filter.drawerOpen],
    filter.drawerOpen,
    true,
  )
  const users = usersResponse?.data?.users || []

  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <select textfieldinput="true" label="Categoria" name="category">
        <option value="" />
        {LIST_OF_CATEGORIES.map((category, index) => (
          <option key={index} value={category}>
            {category}
          </option>
        ))}
      </select>
      <select
        multipleselectinput="true"
        label="Responsável"
        name="responsibleId"
        optionvalues={users}
        loading={isUsersLoading}
      />
      <input datepickerinput="true" label="Data da denúncia" name="createdAt" />
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        <option value={ALL_STATUS_ID.PENDING_STATUS_ID}>Pendente</option>
        <option value={ALL_STATUS_ID.FINALIZED_STATUS_ID}>Finalizado</option>
        <option value={ALL_STATUS_ID.CONVERTED_INCIDENT_STATUS_ID}>
          Convertido Incidente
        </option>
      </select>
    </Filters>
  )
}

ComplaintFilters.propTypes = {
  filter: PropTypes.object.isRequired,
}

export default ComplaintFilters
